



















































































































































































import PhoneTextField from '@/components/PhoneTextField.vue'
import { VueForm } from '@/utils/interfaces'
import {
  createGenericTopUp,
  topupClientController,
} from '@/api/Topup/topup.api'
import { crudMixin } from '@/utils/mixins/crudMixin'
import {
  CreateTopUpClientDTO,
  Product,
  TopUp,
  TopUpClient,
  TopUpClientPhones,
} from '@/utils/interfaces/topup.interface'
import { findPhoneNumbersInText, parsePhoneNumber } from 'libphonenumber-js'
import { User } from '@/api/Auth/auth.interface'
import Combobox from '@/components/Combobox.vue'
import { Roles } from '@/plugins/permissions'
import vRules from '~/utils/vRules'
import { productsEnum } from '~/utils/productsCode.constant'
import { PropType } from 'vue'

export default crudMixin.extend({
  components: {
    PhoneTextField,
    Combobox,
  },
  props: {
    products: Array as PropType<Product[]>,
    pretopup: Boolean,
    defaultProduct: { type: String, default: '' },
  },
  data() {
    return {
      crud: {} as TopUp,
      rules: {
        required: (v: any) => !!v || this.$t('validation.field-required'),
      },
      defaultCrud: {
        confirmation_account: '+1',
        client: '',
        phone_number: '+53',
        count: 1,
        product: this.defaultProduct,
      },
      ignore_hold: false,
      getClients: topupClientController.getter,
      registeredNumbers: [] as TopUpClientPhones[],
      Roles,
      clientsNumber: [],
      confirmationAccount: '',
      vRules,
      selectedClient: null as null | TopUpClient,
      colors: {
        [productsEnum.TOPUP]: 'primary',
        [productsEnum.PACKAGE]: 'secondary',
        [productsEnum.Nauta]: 'info',
      },
    }
  },
  watch: {
    'crud.client'() {
      this.clientsNumber = []
    },
    defaultProduct(v: string) {
      this.crud.product = v
    },
  },
  computed: {
    profile(): User {
      return this.$store.getters.profile
    },
    productsGroup() {
      const groups = new Map<string, Product[]>()
      for (const product of this.products) {
        const group = groups.get(product.code)
        if (group) {
          group.push(product)
        } else {
          groups.set(product.code, [product])
        }
      }
      groups.forEach(value => {
        value.sort((a, b) => a.amount - b.amount)
      })
      return Object.fromEntries(groups)
    },
  },
  methods: {
    onClick(clientPhone: TopUpClientPhones) {
      if (this.crud.phone_number === '+53') {
        this.crud.phone_number = clientPhone.phone
      }
    },
    async onCheck(value: boolean) {
      if (value) {
        const response = await this.$alert({
          title: this.$t('confirm_to_send_topups_now'),
          content: this.$t('your_topups_will_be_sent_now'),
          color: 'error',
        })
        if (!response) this.ignore_hold = false
      }
    },
    onPaste(event: ClipboardEvent) {
      event.preventDefault()
      if (event.clipboardData) {
        const value = event.clipboardData.getData('Text')
        const numbers = findPhoneNumbersInText(value, 'CU')
        if (numbers.length) {
          this.crud.phone_number = numbers[0].number.number as string
        }
      }
    },
    async createTopUp() {
      if (!this.crud.product) {
        this.$toast.info(this.$t('please_select_a_product_before_continue'))
        return
      }

      const isSure = await this.$alert({
        title: this.$t('confirm_to_send_topups'),
        content: this.$t('confirm_you_are_sure_about_your_selection'),
        color: 'error',
      })

      if (!isSure) return

      if ((this.crud.confirmation_account || '').length < 5) {
        this.crud.confirmation_account = ''
        await this.$nextTick()
      }
      if (!(this.$refs.form as VueForm).validate()) return
      let body = {} as any
      if (this.clientsNumber.length > 1) {
        body = {
          topup_requests: this.clientsNumber.map(i => ({
            ...this.crud,
            phone_number: i,
            confirmation_account:
              this.confirmationAccount || this.crud.confirmation_account,
          })),
          ignore_hold: this.ignore_hold,
        }
      } else {
        body = {
          topup_requests: [
            {
              ...this.crud,
              confirmation_account:
                this.confirmationAccount || this.crud.confirmation_account,
            },
          ],
          ignore_hold: this.ignore_hold,
        }
      }
      const response = await createGenericTopUp(body)
      try {
        await this.updateClient()
      } catch {}
      this.resetCrud()
      this.confirmationAccount = ''
      this.crud.product = this.defaultProduct
      ;(this.$refs.form as VueForm).resetValidation()
      return response
    },
    onChange(event: TopUpClient) {
      if (!event || typeof event === 'string') return

      this.selectedClient = event
      this.crud.client = event.first_name
      this.crud.confirmation_account = event.phone
      this.registeredNumbers = event.topup_phones
    },
    async updateClient() {
      if (
        ![Roles.ADMIN, Roles.EMPLOYEE].includes(this.$store.state.profile.role)
      )
        return
      const number = parsePhoneNumber(this.crud.confirmation_account || '')
      if (
        this.selectedClient?.uuid &&
        this.crud.client === this.selectedClient.first_name
      ) {
        const phone = this.selectedClient.topup_phones.find(
          phone => phone.phone === this.crud.phone_number,
        )
        if (phone) {
          phone.last_used = new Date().toISOString()
        } else {
          this.selectedClient.topup_phones.push({
            phone: this.crud.phone_number,
            last_used: new Date().toISOString(),
          })
        }
        await topupClientController.createOrUpdateJson(this.selectedClient)
        return
      }
      const { data } = await topupClientController.getter({
        phone: `${number.countryCallingCode}${number.nationalNumber}`,
        first_name: this.crud.client,
      })

      if (data.results.length) {
        const [client] = data.results
        const phone = client.topup_phones.find(
          phone => phone.phone === this.crud.phone_number,
        )
        if (phone) {
          phone.last_used = new Date().toISOString()
        } else {
          client.topup_phones.push({
            phone: this.crud.phone_number,
            last_used: new Date().toISOString(),
          })
        }
        await topupClientController.createOrUpdateJson(client)
      } else {
        const body = {
          first_name: this.crud.client,
          last_name: '',
          phone: this.crud.confirmation_account,
          topup_phones: [
            {
              phone: this.crud.phone_number,
              last_used: new Date().toISOString(),
            },
          ],
        } as CreateTopUpClientDTO
        await topupClientController.createOrUpdateJson(body)
      }
    },
  },
})
